// extracted by mini-css-extract-plugin
export default {"education":"Education_education__TMHVq","heading":"Education_heading__4b5-E","project__list":"Education_project__list__ET9Tl"};